"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.submitUnzerPayment = void 0;
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _constants = require("../constants");
const submitUnzerPayment = exports.submitUnzerPayment = /*#__PURE__*/function () {
  var _ref = (0, _asyncToGenerator2.default)(function* (paymentMethod, paymentMethodForm, paymentInstance) {
    if (paymentInstance && paymentMethod) {
      yield paymentInstance.createResource().then(function (result) {
        var _result$expiryDate, _result$expiryDate2;
        switch (paymentMethod) {
          case _constants.PAYMENT_METHODS.unzer_cards:
            // @ts-ignore
            paymentMethodForm.setValue('resourceIdCard', result === null || result === void 0 ? void 0 : result.id);
            // @ts-ignore
            paymentMethodForm.setValue('number', result === null || result === void 0 ? void 0 : result.number);
            // @ts-ignore
            paymentMethodForm.setValue('holder', result === null || result === void 0 ? void 0 : result.cardHolder);
            // @ts-ignore
            paymentMethodForm.setValue('cardType', result === null || result === void 0 ? void 0 : result.brand);
            // @ts-ignore
            paymentMethodForm.setValue('expirationMonth', result === null || result === void 0 ? void 0 : (_result$expiryDate = result.expiryDate) === null || _result$expiryDate === void 0 ? void 0 : _result$expiryDate.split('/')[0]);
            // @ts-ignore
            paymentMethodForm.setValue('expirationYear', result === null || result === void 0 ? void 0 : (_result$expiryDate2 = result.expiryDate) === null || _result$expiryDate2 === void 0 ? void 0 : _result$expiryDate2.split('/')[1]);
            break;
          case _constants.PAYMENT_METHODS.unzer_paypal:
            // @ts-ignore
            paymentMethodForm.setValue('resourceIdPaypal', result === null || result === void 0 ? void 0 : result.id);
            // @ts-ignore
            paymentMethodForm.setValue('email', result === null || result === void 0 ? void 0 : result.email);
            break;
          case _constants.PAYMENT_METHODS.unzer_invoice:
            const threatMetrixInvoiceId = document.querySelectorAll('[id^=tmSessionId]')[0];
            const threatMetrixIdSessionInvoiceId = threatMetrixInvoiceId.value;
            paymentMethodForm.setValue('tmSessionId', threatMetrixIdSessionInvoiceId);
            paymentMethodForm.setValue('resourceIdInvoice', result === null || result === void 0 ? void 0 : result.id);
            break;
          case _constants.PAYMENT_METHODS.unzer_direct_debit_secured:
            const ibanInput = document.querySelectorAll('[id^=unzer-iban-input-]')[0];
            const iban = ibanInput.value;
            const holderInput = document.querySelectorAll('[id^=unzer-holder-input-]')[0];
            const holder = holderInput.value;
            const threatMetrixDebitId = document.querySelectorAll('[id^=tmSessionId]')[0];
            const threatMetrixIdSessionDebitId = threatMetrixDebitId.value;
            paymentMethodForm.setValue('resourceIdDirectDebitSecure', result === null || result === void 0 ? void 0 : result.id);
            paymentMethodForm.setValue('tmSessionId', threatMetrixIdSessionDebitId);
            paymentMethodForm.setValue('holderDD', holder);
            paymentMethodForm.setValue('ibanDD', iban);
          default:
            break;
        }
      });
    }
  });
  return function submitUnzerPayment(_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}();